import { Component } from '@angular/core';
import { GITHUB_URL, LIB_VERSION, NPM_URL, RELEASES_URL } from '../version';

/** Глобальный футер: версия библиотеки + внешние ссылки. */
@Component({
  selector: 'app-site-footer',
  standalone: true,
  template: `
    <span>ngx-aur-mat-table v{{ version }}</span>
    <a [href]="githubUrl" target="_blank" rel="noopener">GitHub</a>
    <a [href]="npmUrl" target="_blank" rel="noopener">npm</a>
    <a [href]="releasesUrl" target="_blank" rel="noopener">Changelog</a>
  `,
  styles: [`
    :host {
      display: flex; gap: 18px; align-items: center; justify-content: center;
      padding: 22px;
      background: var(--dark-1); color: #8e8ca6; font-size: 13px;
    }
    a { text-decoration: none; color: #b9b7c9; }
    a:hover { color: #fff; }
  `],
})
export class SiteFooterComponent {
  readonly version = LIB_VERSION;
  readonly npmUrl = NPM_URL;
  readonly githubUrl = GITHUB_URL;
  readonly releasesUrl = RELEASES_URL;
}
